export default "__VITE_ASSET__t3gZ9lbU__"